import React from 'react';
import { Link } from 'react-router-dom';
import List from 'antd/lib/list';
import 'antd/lib/list/style/index.css';
var ListAthlete = function (props) { return (React.createElement(List, { itemLayout: 'horizontal', dataSource: props.athleteDocs, locale: { emptyText: 'No athletes in team' }, renderItem: function (athlete) {
        return (React.createElement(List.Item, { actions: [
                React.createElement("a", { onClick: function () {
                        if (!props.isDisabled) {
                            props.handleRemoveAthlete(athlete.id);
                        }
                    } }, "Remove"),
            ] },
            React.createElement(List.Item.Meta, { title: (React.createElement(Link, { to: "/event/" + props.event.subdomain + "/athletes/" + athlete.id }, athlete.name)) }),
            React.createElement("div", null, "\u00A0")));
    } })); };
export default ListAthlete;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormTeamPage/FormTeam/ListAthlete.tsx
// module id = 1197
// module chunks = 0